import version_1_0_0 from './version_1_0_0.mjs';
import version_1_1_0 from './version_1_1_0.mjs';
import version_1_1_1 from './version_1_1_1.mjs';
import version_1_1_2 from './version_1_1_2.mjs';
import version_1_2_0 from './version_1_2_0.mjs';
import version_1_2_1 from './version_1_2_1.mjs';
import version_1_2_2 from './version_1_2_2.mjs';
import version_1_2_3 from './version_1_2_3.mjs';
import version_1_3_0 from './version_1_3_0.mjs';
import version_1_3_1 from './version_1_3_1.mjs';
import version_1_3_2 from './version_1_3_2.mjs';
import version_1_3_3 from './version_1_3_3.mjs';
import version_1_3_4 from './version_1_3_4.mjs';
import version_1_3_5 from './version_1_3_5.mjs';
import version_1_3_6 from './version_1_3_6.mjs';
import version_1_3_7 from './version_1_3_7.mjs';
import version_1_3_8 from './version_1_3_8.mjs';
import version_1_3_9 from './version_1_3_9.mjs';
import version_1_4_0 from './version_1_4_0.mjs';
import version_1_4_1 from './version_1_4_1.mjs';
import version_1_4_2 from './version_1_4_2.mjs';
import version_1_4_3 from './version_1_4_3.mjs';
import version_1_4_4 from './version_1_4_4.mjs';
import version_1_4_5 from './version_1_4_5.mjs';
import version_1_4_6 from './version_1_4_6.mjs';
import version_1_4_7 from './version_1_4_7.mjs';
import version_1_4_8 from './version_1_4_8.mjs';
import version_1_4_9 from './version_1_4_9.mjs';
import version_1_4_10 from './version_1_4_10.mjs';
import version_1_4_11 from './version_1_4_11.mjs';
import version_1_4_12 from './version_1_4_12.mjs';
import version_1_4_13 from './version_1_4_13.mjs';

const challengeConfig = {
  "versions": [
    {
      "version": "1.0.0",
      "start": 1,
      "stop": 8702342
    },
    {
      "version": "1.1.0",
      "start": 8702343,
      "stop": 17400685
    },
    {
      "version": "1.1.1",
      "start": 17400686,
      "stop": 17747172
    },
    {
      "version": "1.1.2",
      "start": 17747173,
      "stop": 18219928
    },
    {
      "version": "1.2.0",
      "start": 18219929,
      "stop": 20036708
    },
    {
      "version": "1.2.1",
      "start": 20036709,
      "stop": 20385101
    },
    {
      "version": "1.2.2",
      "start": 20385102,
      "stop": 21956002
    },
    {
      "version": "1.2.3",
      "start": 21956003,
      "stop": 23677000,
    },
    {
      "version": "1.3.0",
      "start": 23677001,
      "stop": 23837000
    },
    {
      "version": "1.3.1",
      "start": 23837001,
      "stop": 23885000
    },
    {
      "version": "1.3.2",
      "start": 23885001,
      "stop": 24059000
    },
    {
      "version": "1.3.3",
      "start": 24059001,
      "stop": 24247000
    },
    {
      "version": "1.3.4",
      "start": 24247001,
      "stop": 24444000
    },
    {
      "version": "1.3.5",
      "start": 24444001,
      "stop": 26080000
    },
    {
      "version": "1.3.6",
      "start": 26080001,
      "stop": 27685000
    },
    {
      "version": "1.3.7",
      "start": 27685001,
      "stop": 28075000
    },
    {
      "version": "1.3.8",
      "start": 28075001,
      "stop": 28380000
    },
    {
      "version": "1.3.9",
      "start": 28380001,
      "stop": 30200000
    },
    {
      "version": "1.4.0",
      "start": 30200001,
      "stop": 30280000
    },
    {
      "version": "1.4.1",
      "start": 30280001,
      "stop": 30500000
    },
    {
      "version": "1.4.2",
      "start": 30500001,
      "stop": 31500000
    },
    {
      "version": "1.4.3",
      "start": 31500001,
      "stop": 33080000
    },
    {
      "version": "1.4.4",
      "start": 33080001,
      "stop": 34900000
    },
    {
      "version": "1.4.5",
      "start": 34900001,
      "stop": 35240000
    },
    {
      "version": "1.4.6",
      "start": 35240001,
      "stop": 39010000
    },
    {
      "version": "1.4.7",
      "start": 39010001,
      "stop": 42460000
    },
    {
      "version": "1.4.8",
      "start": 42460001,
      "stop": 44120000
    },
    {
      "version": "1.4.9",
      "start": 44120001,
      "stop": 45445000
    },
    {
      "version": "1.4.10",
      "start": 45445001,
      "stop": 48810000
    },
    {
      "version": "1.4.11",
      "start": 48810001,
      "stop": 50334000
    },
    {
      "version": "1.4.12",
      "start": 50334001,
      "stop": 52388899
    },
    {
      "version": "1.4.13",
      "start": 52388900,
      "stop": 9007199254740998
    },
  ],
  "weapons": {
    "default": {
      "gun": "rifle.png"
    },
    "primary": {
      "AR-23 Liberator": "primary/assault/ar-23.png",
      "AR-23A Liberator Carbine": "primary/assault/ar-23a.png",
      "AR-23C Liberator Concussive": "primary/assault/ar-23c.png",
      "AR-23P Liberator Penetrator": "primary/assault/ar-23p.png",
      "AR-61 Tenderizer": "primary/assault/ar-61.png",
      "ARC-12 Blitzer": "primary/energy/arc-12.png",
      "BR-14 Adjudicator": "primary/marksman/br-14.png",
      "CB-9 Exploding Crossbow": "primary/explosive/cb-9.png",
      "FLAM-66 Torcher": "primary/special/flam-66.png",
      "JAR-5 Dominator": "primary/special/jar-5.png",
      "LAS-16 Sickle": "primary/energy/las-16.png",
      "LAS-5 Scythe": "primary/energy/las-5.png",
      "MP-98 Knight": "primary/smg/mp-98.png",
      "Plas-1 Scorcher": "primary/energy/plas-1.png",
      "Plas-101 Purifier": "primary/energy/plas-101.png",
      "R-2124 Constitution": "primary/marksman/r-2124.png",
      "R-36 Eruptor": "primary/explosive/r-36.png",
      "R-63 Diligence": "primary/marksman/r-63.png",
      "R-63CS Diligence Counter Sniper": "primary/marksman/r-63cs.png",
      "SG-20 Halt": "primary/shotgun/halt.png",
      "SG-225 Breaker": "primary/shotgun/breaker.png",
      "SG-225IE Breaker Incendiary": "primary/shotgun/breaker-incendiary.png",
      "SG-225SP Breaker SPRAY&PRAY": "primary/shotgun/breaker-spray.png",
      "SG-225SP Sweeper": "primary/shotgun/sweeper.png",
      "SG-451 Cookout": "primary/shotgun/sg-451.png",
      "SG-8 Punisher": "primary/shotgun/punisher.png",
      "SG-8P Punisher Plasma": "primary/energy/sg-8p.png",
      "SG-8S Slugger": "primary/shotgun/slugger.png",
      "SMG-32 Reprimand": "primary/smg/reprimand.png",
      "SMG-37 Defender": "primary/smg/smg-37.png",
      "SMG-72 Pummeler": "primary/smg/smg-72.png",
      "StA-52 Assault Rifle": "primary/assault/sta-52.png",
      "StA-11 SMG": "primary/smg/sta-11.png",
      "PLAS-39 Accelerator Rifle": "primary/marksman/plas-39.png",
      "LAS-17 Double-Edge Sickle": "primary/energy/las-17.png",
      "R-6 Deadeye": "primary/marksman/r-6.png",
      "R-2 Amendment": "primary/marksman/r-2.png",
      "AR-32 Pacifier": "primary/assault/ar-32.png",
      "VG-70 Variable": "primary/special/vg-70.png",
      "MA5C Assault Rifle": "primary/assault/ma5c.png",
      "M7S SMG": "primary/smg/m7s.png",
      "M90A Shotgun": "primary/shotgun/m90a.png",
      "AR-2 Coyote": "primary/assault/ar-2.png",
      "AR/GL-21 One-Two": "primary/assault/ar-gl-21.png",
      "DBS-2 Double Freedom": "primary/shotgun/dbs-2.png",
      "R-72 Censor": "primary/marksman/r-72.png",
      "AR-59 Suppressor": "primary/assault/ar-59.png",
      "LAS-16 Trident": "primary/energy/las-16-trident.png",
      "SMG/FLAM-34 Stoker": "primary/smg/smg-flam-34.png",
      "SMG-203 Gallant": "primary/smg/smg-203.png",
      "R-4 Hyena": "primary/marksman/r-4.png",
      "R/40-K Hot-Shot": "primary/marksman/r-40-k.png",
      "AR-11 Arbitrator": "primary/assault/ar-11-arbitrator.png",
      "GL-15 Evictor": "primary/explosive/gl-15-evictor.png",
    },
    "secondary": {
      "GP-31 Grenade Pistol": "secondary/gp-31.png",
      "LAS-7 Dagger": "secondary/las-7.png",
      "P-2 Peacemaker": "secondary/p2-p.png",
      "P-4 Senator": "secondary/p-4s.png",
      "P-11 Stim Pistol": "secondary/p11-s.png",
      "P-19 Redeemer": "secondary/p2-r.png",
      "P-72 Crisper": "secondary/p-72.png",
      "P-113 Verdict": "secondary/p-113.png",
      "PLAS-15 Loyalist": "secondary/plas-15.png",
      "SG-22 Bushwhacker": "secondary/sg-22.png",
      "CQC-19 Stun Lance": "secondary/cqc-19.png",
      "CQC-30 Stun Baton": "secondary/cqc-30.png",
      "CQC-5 Combat Hatchet": "secondary/cqc-5.png",
      "GP-31 Ultimatum": "secondary/gp-31-u.png",
      "LAS-58 Talon": "secondary/las-58.png",
      "CQC-2 Saber": "secondary/cqc-2.png",
      "P-92 Warrant": "secondary/p-92.png",
      "M6C/SOCOM Pistol": "secondary/m6c.png",
      "CQC-42 Machete": "secondary/cqc-42.png",
      "P-35 Re-Educator": "secondary/p-35.png",
      "CQC-73 Entrenchment Tool": "secondary/cqc-73.png",
      "P-69 Veto": "secondary/p-69.png",
      "P-33 Missile Pistol": "secondary/p-33.png",
      "P/40-K Bolt Pistol": "secondary/p-40-k.png",
      "P-34 Breacher": "secondary/p-34-breacher.png",
    },
    "grenade": {
      "G-3 Smoke": "grenade/smoke.png",
      "G-4 Gas Grenade": "grenade/gas.png",
      "G-6 Frag": "grenade/frag.png",
      "G-10 Incendiary": "grenade/incendiary.png",
      "G-12 High Explosive": "grenade/explosive.png",
      "G-13 Incendiary Impact": "grenade/g-13.png",
      "G-16 Impact": "grenade/impact.png",
      "G-23 Stun": "grenade/stun.png",
      "G-123 Thermite": "grenade/thermite.png",
      "K-2 Throwing Knife": "grenade/k2.png",
      "G-50 Seeker": "grenade/g-50.png",
      "TED-63 Dynamite": "grenade/ted-63.png",
      "G-142 Pyrotech": "grenade/g-142.png",
      "G-109 Urchin": "grenade/g-109.png",
      "G-31 Arc": "grenade/g-31.png",
      "G-7 Pineapple": "grenade/g-7.png",
      "TM-1 Lure Mine": "grenade/tm-1.png",
      "G/SH-39 Shield": "grenade/gsh-39.png",
      "G-89 Smokescreen": "grenade/g-89.png",
      "G-48 Giga Grenade": "grenade/giga-grenade.png",
      "G/40-K Melta Mine": "grenade/g-40-k.png",
      "G-8 Immolation": "grenade/g-8-immolation.png",
      "G-60 Anti-Tank Seeker": "grenade/g-60-anti-tank-seeker.png",
    },
  },
  "stratagems": {
    "A/AC-8 Autocannon Sentry": "Robotics Workshop/Autocannon Sentry.svg",
    "A/ARC-3 Tesla Tower": "Bridge/Tesla Tower.svg",
    "A/G-16 Gatling Sentry": "Robotics Workshop/Gatling Sentry.svg",
    "A/M-12 Mortar Sentry": "Robotics Workshop/Mortar Sentry.svg",
    "A/M-23 EMS Mortar Sentry": "Robotics Workshop/EMS Mortar Sentry.svg",
    "A/MG-43 Machine Gun Sentry": "Robotics Workshop/Machine Gun Sentry.svg",
    "A/MLS-4X Rocket Sentry": "Robotics Workshop/Rocket Sentry.svg",
    "AC-8 Autocannon": "Patriotic Administration Center/Autocannon.svg",
    "APW-1 Anti-Material Rifle": "Patriotic Administration Center/Anti-Materiel Rifle.svg",
    "ARC-3 Arc Thrower": "Engineering Bay/Arc Thrower.svg",
    "AX/AR-23 Guard Dog": "Robotics Workshop/Guard Dog.svg",
    "AX/TX-13 Guard Dog Dog Breath": "Chemical Agents/Guard Dog Breath.svg",
    "AX/LAS-5 Guard Dog Rover": "Engineering Bay/Guard Dog Rover.svg",
    "B-1 Supply Pack": "Engineering Bay/Supply Pack.svg",
    "Dark Fluid Vessel": "General Stratagems/Dark Fluid Vessel.svg",
    "E/MG-101 HMG Emplacement": "Bridge/HMG Emplacement.svg",
    "Eagle 110m Rocket Pods": "Hangar/Eagle 110MM Rocket Pods.svg",
    "Eagle 500kg Bomb": "Hangar/Eagle 500KG Bomb.svg",
    "Eagle Airstrike": "Hangar/Eagle Airstrike.svg",
    "Eagle Cluster Bomb": "Hangar/Eagle Cluster Bomb.svg",
    "Eagle Napalm Airstrike": "Hangar/Eagle Napalm Airstrike.svg",
    "Eagle Smoke Strike": "Hangar/Eagle Smoke Strike.svg",
    "Eagle Strafing Run": "Hangar/Eagle Strafing Run.svg",
    "EAT-17 Expendable Anti-Tank": "Patriotic Administration Center/Expendable Anti-Tank.svg",
    "EXO-45 Patriot Exosuit": "Robotics Workshop/Patriot Exosuit.svg",
    "EXO-49 Emancipator Exosuit": "Robotics Workshop/Emancipator Exosuit.svg",
    "FAF-14 Spear": "Patriotic Administration Center/Spear.svg",
    "FLAM-40 Flamethrower": "Patriotic Administration Center/Flamethrower.svg",
    "FX-12 Shield Generator Relay": "Bridge/Shield Generator Relay.svg",
    "GL-21 Grenade Launcher": "Engineering Bay/Grenade Launcher.svg",
    "GR-8 Recoilless Rifle": "Patriotic Administration Center/Recoilless Rifle.svg",
    "Hellbomb": "General Stratagems/Hellbomb.svg",
    "Hive Breaker Drill": "General Stratagems/Hive Breaker Drill.svg",
    "LAS-98 Laser Cannon": "Engineering Bay/Laser Cannon.svg",
    "LAS-99 Quasar Cannon": "Engineering Bay/Quasar Cannon.svg",
    "LIFT-850 Jump Pack": "Hangar/Jump Pack.svg",
    "M-105 Stalwart": "Patriotic Administration Center/Stalwart.svg",
    "MD-17 Anti-Tank Mines": "Engineering Bay/Anti-Tank Mines.svg",
    "MD-6 Anti-Personnel Minefield": "Engineering Bay/Anti-Personnel Minefield.svg",
    "MD-I4 Incendiary Mines": "Engineering Bay/Incendiary Mines.svg",
    "MG-206 Heavy Machine Gun": "Patriotic Administration Center/Heavy Machine Gun.svg",
    "MG-43 Machine Gun": "Patriotic Administration Center/Machine Gun.svg",
    "MLS-4X Commando": "Patriotic Administration Center/Commando.svg",
    "Orbital 120MM HE Barrage": "Orbital Cannons/Orbital 120MM HE Barrage.svg",
    "Orbital 380MM HE Barrage": "Orbital Cannons/Orbital 380MM HE Barrage.svg",
    "Orbital Airburst Strike": "Orbital Cannons/Orbital Airburst Strike.svg",
    "Orbital EMS Strike": "Bridge/Orbital EMS Strike.svg",
    "Orbital Gas Strike": "Bridge/Orbital Gas Strike.svg",
    "Orbital Gatling Barage": "Orbital Cannons/Orbital Gatling Barrage.svg",
    "Orbital Illumination Flare": "General Stratagems/Orbital Illumination Flare.svg",
    "Orbital Laser": "Orbital Cannons/Orbital Laser.svg",
    "Orbital Napalm Barrage": "Orbital Cannons/Orbital Napalm Barrage.svg",
    "Orbital Precision Strike": "Bridge/Orbital Precision Strike.svg",
    "Orbital Railcannon Strike": "Orbital Cannons/Orbital Railcannon Strike.svg",
    "Orbital Smoke Strike": "Bridge/Orbital Smoke Strike.svg",
    "Orbital Walking Barrage": "Orbital Cannons/Orbital Walking Barrage.svg",
    "Prospecting Drill": "General Stratagems/Prospecting Drill.svg",
    "Reinforce": "General Stratagems/Reinforce.svg",
    "Resupply": "General Stratagems/Resupply.svg",
    "RL-77 Airburst Rocket Launcher": "Patriotic Administration Center/Airburst Rocket Launcher.svg",
    "RS-422 Railgun": "Patriotic Administration Center/Railgun.svg",
    "SEAF Artillery": "General Stratagems/SEAF Artillery.svg",
    "SH-20 Balistic Shield Backpack": "Engineering Bay/Ballistic Shield Backpack.svg",
    "SH-32 Shield Generator Pack": "Engineering Bay/Shield Generator Pack.svg",
    "SOS Beacon": "General Stratagems/SOS Beacon.svg",
    "Super Earth Flag": "General Stratagems/Super Earth Flag.svg",
    "Tectonic Drill": "General Stratagems/Tectonic Drill.svg",
    "TX-41 Sterilizer": "Chemical Agents/Sterilizer.svg",
    "Upload Data": "General Stratagems/Upload Data.svg",
    "SH-51 Directional Shield": "Urban Legends/Directional Shield.svg",
    "A/FLAM-40 Flame Sentry": "Urban Legends/Flame Sentry.svg",
    "E/AT-12 Anti-Tank Emplacement": "Urban Legends/Anti-Tank Emplacement.svg",
    "M-102 Fast Recon Vehicle": "Hangar/Fast Recon Vehicle.svg",
    "StA-X3 W.A.S.P. Launcher": "Patriotic Administration Center/StA-X3 W.A.S.P. Launcher.svg",
    "Portable Hellbomb": "Servants of Freedom/Hellbomb Portable.svg",
    "B-100 Portable Hellbomb": "Servants of Freedom/Hellbomb Portable.svg",
    "MD-8 Gas Mines": "Engineering Bay/Gas Mine.svg",
    "LIFT-860 Hover Pack": "Borderline Justice/Hover Pack.svg",
    "E/GL-21 Grenadier Battlement": "Bridge/Grenadier Battlement.svg",
    "One True Flag": "Masters of Ceremony/One True Flag.svg",
    "CQC-1 One True Flag": "Masters of Ceremony/One True Flag.svg",
    "GL-52 De-Escalator": "Force of Law/GL-52 De-Escalator.svg",
    "Guard Dog K-9": "Force of Law/Guard Dog K-9.svg",
    "AX/ARC-3 Guard Dog K-9": "Force of Law/Guard Dog K-9.svg",
    "Plas-45 Epoch": "Control Group/Epoch.svg",
    "A/LAS-98 Laser Sentry": "Control Group/Laser Sentry.svg",
    "LIFT-182 Warp Pack": "Control Group/Warp Pack.svg",
    "MS-11 Solo Silo": "Dust Devils/Solo Silo.svg",
    "EAT-700 Expendable Napalm": "Dust Devils/Expendable Napalm.svg",
    "S-11 Speargun": "Dust Devils/Speargun.svg",
    "CQC-9 Defoliation Tool": "Python Commandos/Defoliation Tool.svg",
    "AZ/FLAM-75 Guard Dog Hot Dog": "Python Commandos/Guard Dog Hot Dog.svg",
    "M-1000 Maxigun": "Python Commandos/Maxigun.svg",
    "B/MD C4 Pack": "Redacted Regiment/C4 Pack.svg",
    "GL-28 Belt-Fed Grenade Launcher": "Siege Breakers/GL-28.svg",
    "EAT-411 Leveller": "Siege Breakers/EAT-411.svg",
    "CQC-20 Breaching Hammer": "Siege Breakers/CQC-20.svg",
    "TD-220 Bastion MK XVI": "Siege Breakers/Bastion MK XVI.svg",
    "A/GM-17 Gas Mortar Sentry": "Entrenched Division/Gas Mortar Sentry.svg",
    "B/FLAM-80 Cremator": "Entrenched Division/Cremator.svg",
    "MGX-42 Bullet Storm": "Exo Experts/Bullet Storm.svg",
    "EXO-51 Lumberer Exosuit": "Exo Experts/Lumberer Exosuit.svg",
    "EXO-55 Breakthrough Exosuit": "Exo Experts/Breakthrough Exosuit.svg",
    "M-103 Supply FRV": "Hangar/Supply FRV.svg",
    "40-K Meltagun": "Castellan’s Creed/40-K Meltagun.svg",
  },
  "1.0.0": version_1_0_0,
  "1.1.0": version_1_1_0,
  "1.1.1": version_1_1_1,
  "1.1.2": version_1_1_2,
  "1.2.0": version_1_2_0,
  "1.2.1": version_1_2_1,
  "1.2.2": version_1_2_2,
  "1.2.3": version_1_2_3,
  "1.3.0": version_1_3_0,
  "1.3.1": version_1_3_1,
  "1.3.2": version_1_3_2,
  "1.3.3": version_1_3_3,
  "1.3.4": version_1_3_4,
  "1.3.5": version_1_3_5,
  "1.3.6": version_1_3_6,
  "1.3.7": version_1_3_7,
  "1.3.8": version_1_3_8,
  "1.3.9": version_1_3_9,
  "1.4.0": version_1_4_0,
  "1.4.1": version_1_4_1,
  "1.4.2": version_1_4_2,
  "1.4.3": version_1_4_3,
  "1.4.4": version_1_4_4,
  "1.4.5": version_1_4_5,
  "1.4.6": version_1_4_6,
  "1.4.7": version_1_4_7,
  "1.4.8": version_1_4_8,
  "1.4.9": version_1_4_9,
  "1.4.10": version_1_4_10,
  "1.4.11": version_1_4_11,
  "1.4.12": version_1_4_12,
  "1.4.13": version_1_4_13,
};

export default challengeConfig;
